import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common'

@Pipe({
  name: 'balanceAndBoltonsDate'
})
export class BalanceAndBoltonsDatePipe implements PipeTransform {
  transform(value: string, args?: any): any {
    return (value.substring(0, 10)).replace('-', '.').replace('-', '.');
  }

}



@Pipe({
  name: 'balanceAndBoltonsDateDiff'
})
export class BalanceAndBoltonsDateDiff implements PipeTransform {
  transform(value: Date, args?: any): number {
    let date1 = new Date(formatDate(value, 'M/d/yy', 'en-US'));
    let date2 = new Date(formatDate(new Date(), 'M/d/yy', 'en-US'));
    let difference_In_Time = date1.getTime() - date2.getTime();
    return difference_In_Time / (1000 * 3600 * 24);
  }

}



@Pipe({
  name: 'balanceAndBoltonsDateHoursDiff'
})
export class BalanceAndBoltonsDateHoursDiff implements PipeTransform {
  transform(value: Date, args?: any): number {
    let value2= value.toString().substring(0, 19);
    console.log(value2);
    let date1 = new Date(formatDate(value2, 'yyyy-MM-dd HH:mm:ss', 'en-US'));
    console.log(date1);
    let date2 = new Date(formatDate(new Date(), 'yyyy-MM-dd HH:mm', 'en-US'));
     console.log(date2);
    let difference_In_Time = date1.getHours() -   date2.getHours();
    return difference_In_Time;
  }

}